import {
    Component,
    computed,
    EventEmitter,
    Input,
    OnInit,
    Output,
    signal,
    TemplateRef,
    WritableSignal
} from '@angular/core';
import {DialogModule} from "primeng/dialog";
import {ListboxModule} from "primeng/listbox";
import {MessagesModule} from "primeng/messages";
import {NgIf} from "@angular/common";
import {PrimeTemplate} from "primeng/api";
import {PrimeNgModule} from "../../../../../shared/prime-ng/prime-ng.module";
import {
    EvalInterface, FasesEval, FasesTramites,
    SolicitudEvalTramiteFase, TramiteEvaluacion
} from "../../../../../officials/evaluaciones/interfaces/evaluaciones.interface";
import {CatalogoInterface, ProyectoItem} from "../../../../interfaces/proyecto.interface";
import {Ripple} from "primeng/ripple";
import Swal from "sweetalert2";
import {EvaluacionesService} from "../../../../../officials/evaluaciones/services/evaluaciones.service";
import {TramiteService} from "../../../../tramites/services/tramite.service";
import {CatalogoService} from "../../../../../shared/services/catalogo-service";

@Component({
  selector: 'app-fase-tramite-evaluacion',
  standalone: true,
    imports: [
        DialogModule,
        ListboxModule,
        MessagesModule,
        NgIf,
        PrimeTemplate,
        PrimeNgModule,
        Ripple
    ],
  templateUrl: './fase-tramite-evaluacion.component.html',
  styleUrl: './fase-tramite-evaluacion.component.scss'
})
export class FaseTramiteEvaluacionComponent implements OnInit {
    @Input() visible: boolean = false;
    @Input() selected: ProyectoItem | null = null;
    @Input() datosCargados!: boolean;
    @Input() loading!: TemplateRef<any>;
    @Input() evaluacion!:EvalInterface
    @Output() closeDialogEvent = new EventEmitter<void>();
    selectAll = false;
    validSelectedFase =false;
    selectedTramites: TramiteEvaluacion [] = [];
    opcionesFases: FasesEval []= [];
    fases: CatalogoInterface[] = [];
    selectedFases!: FasesEval;
    loadingButton: boolean = false;
    fasesTramites: WritableSignal<FasesTramites[]> = signal([])
    constructor(private evaluacionesService:EvaluacionesService ,private catalogoService:CatalogoService, protected tramiteService:TramiteService, private evaluacioneService:EvaluacionesService) {
    }
    ngOnInit(): void {
        this.getFases();
        this.opcionesFases=this.fasesToEval()
    }
    private getFases() {
        this.catalogoService.getCatalogo("fase")
            .subscribe({
                next: (result) => {
                    this.fases=result!;
                },
                error: (error) => {
                    console.log(error)
                },
                complete: () => {
                }
            });
    }
    obtenerTramitesFasesEvaluacion() {
        if(this.tramiteService.idProyecto()!==null){
            this.tramiteService.getTramitesFasesEvaluacion(Number.parseInt(this.tramiteService.idProyecto()!),"noEvaluaciones");
        }
    }
    private getEvaluacionesPorSolicitud(idSolicitud:number) {
        this.evaluacioneService.obtenerEvaluacionSolicitud(idSolicitud)
            .subscribe({
                next: (result) => {
                    if (result.status == 200) {
                        this.evaluacioneService._evaluacionesSolicitud.set(result.body!);
                    }
                },
                error: (error) => {
                    console.log(error)
                },
                complete: () => {
                }
            });
    }
    guardar() {
        if(this.selected?.idSolicitudTipo==1 && this.selectedFases==null){
            this.validSelectedFase=true;
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Ocurrió un error debe seleccionar la fase a evaluar.",
                showDenyButton: true,
                showConfirmButton: false,
                denyButtonText: `Ok`,
                timer:3000
            });
            return;
        }
        if(this.selected?.idSolicitudTipo==2 && this.selectedTramites.length==0){
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Ocurrió un error debe seleccionar tramite de la fase a evaluar.",
                showDenyButton: true,
                showConfirmButton: false,
                denyButtonText: `Ok`,
                timer:3000
            });
            return;
        }
        if (this.selectedTramites.length > 0) {
            this.evaluacion = {
                ...this.evaluacion,
                fasesTramites:this.fasesTramites()
            };
            Swal.fire({
                icon: "question",
                title: "¿Está seguro que desea iniciar la evaluación?",
                html: `
                <ul style="text-align: left; font-size: 1rem; padding-left: 1.2em;">
                  <li>Esta operación cambiará el estado de la solicitud a <b>evaluación</b>.</li>
                  <li>Se asignarán a la evaluación los técnicos vinculados al proyecto.</li>
                  <li>También se agregarán requisitos que serán evaluados por los técnicos definidos por tipo de revisión al momento de su asignación al proyecto.</li>
                  <li>Si no desea incluir a algún técnico, puede removerlo desde la opción
                        <button id="editarAsignacionBtn" style=" margin-left: 8px; border: none; border-radius: 50%; background-color: #fbb52f; color: white; width: 2.5rem; height: 2.5rem; display: inline-flex; align-items: center;
                              justify-content: center;">
                          <i class="pi pi-user-edit" style="font-size: 1rem;"></i>
                        </button></li>
                  <li><b>Esta operación no puede deshacerse.</b></li>
                </ul>
              `,
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: "Sí, confirmar",
                denyButtonText: "No, cancelar",
                confirmButtonColor: "#28a745"
            }).then((result) => {
                if (result.isConfirmed) {
                    this.loadingButton = true;
                    this.evaluacionesService.procesarInicioEvaluacion(this.evaluacion).subscribe({
                        next: (result) => {
                            if (result.status == 200 || result.status == 201) {
                                Swal.fire({
                                    position: "center",
                                    icon: "success",
                                    title: "Éxito se ha procesado correctamente.",
                                    showConfirmButton: false,
                                    timer: 2000
                                });
                            }
                        },
                        error: (error) => {
                            console.log(error)
                            this.loadingButton = false;
                            if(error.status == 409) {
                                Swal.fire({
                                    icon: "error",
                                    title: "Error",
                                    text: "Ocurrió un error al procesar, ya existe evaluación iniciada para esta solicitud verificar las fases y tramites a evaluar",
                                    showDenyButton: true,
                                    showConfirmButton: false,
                                    denyButtonText: `Ok`,
                                    timer:3000
                                });
                            }else{
                                Swal.fire({
                                    icon: "error",
                                    title: "Error",
                                    text: "Ocurrió un error al procesar, intente mas tarde",
                                    showDenyButton: true,
                                    showConfirmButton: false,
                                    denyButtonText: `Ok`,
                                    timer:3000
                                });
                            }
                        },
                        complete: () => {
                            this.obtenerTramitesFasesEvaluacion();
                            this.selectedTramites=[];
                            this.validSelectedFase=false;
                            this.selectedFases=null!;
                            this.getEvaluacionesPorSolicitud(this.selected?.idSolicitud!);
                            this.closeDialog();
                            this.loadingButton = false;
                        }
                    });
                }
            });
        }
    }

    closeDialog() {
        this.closeDialogEvent.emit();
    }
    isSelected(item: any): boolean {
        return item.estadoEval || this.selectedTramites.includes(item);

    }
    onSelectAllChange(event: any) {
        const validItems = this.tramiteService._tramitesFasesEval().flatMap(fase =>
            fase.tramitesEvalResponse.filter(tramite => !tramite.estadoEval)
        );
        this.selectedTramites = event.checked ? validItems : [];
        this.selectAll = event.checked;
    }


    toggleSelection(item: any): void {
        if (item.estadoEval) {  //no permitir seleccionar los ya estan en proceso evaluacion
            return;
        }
        if (this.isSelected(item)) {
            this.selectedTramites = this.selectedTramites.filter(i => i !== item);
        } else {
            this.selectedTramites = [...this.selectedTramites, item];
        }
        console.log("lista seleccionada:", this.selectedTramites);
    }

    /**Metodo que permite que los elementos deshabilitado no se tomen en cuenta p-listbox
     * filter obtiene de la listbox los datos que solo cumple la condicion*/
    onListboxChange(event: any) {
        this.selectedTramites = event.value.filter((item: TramiteEvaluacion) => !item.estadoEval);
        this.obtenerFasesTramitesArray(this.selectedTramites);
    }
    seleccionarTramitesFases(event: any) {
        if (!event.value){ return;}
        if (this.selectedFases==null){return;}
        //seleccionar tramites por fases
        if (this.selectedFases.idFase === 1 || this.selectedFases.idFase === 2 || this.selectedFases.idFase === 3 || this.selectedFases.idFase === 4) {
            this.selectedTramites = this.tramiteService._tramitesFasesEval()
                .flatMap(fase =>  fase.tramitesEvalResponse)
                .filter(tramite => tramite.idFase == this.selectedFases.idFase && !tramite.estadoEval);
            this.validSelectedFase=false;
            this.obtenerFasesTramitesArray(this.selectedTramites);
        }
    }


    /**Metodo que permite obtener los tramites y fase seleccionados*/
    private obtenerFasesTramitesArray(selectedTramites: TramiteEvaluacion[]) {
        const fasesTramites = new Map<number, number[]>();
        selectedTramites.forEach(tramite => {
            let idFase = Number(tramite.idFase);
            let idTramite = Number(tramite.idTramite);
            if (!fasesTramites.has(idFase)) {
                fasesTramites.set(idFase, []);
            }
            fasesTramites.get(idFase)?.push(idTramite);
        });

        // convirtiendo variable map a un array parseado FasesTramites
        let converToArray: FasesTramites[] = Array.from(fasesTramites, ([idFase, idsTramites]) => ({
            idFase,
            idsTramites
        }));
        this.fasesTramites.set(converToArray);
    }

    /**Este metodo valida los estado en los cuales esta permitido inicial evaluacion*/
    validacionIniciarEvaluacion(idSolicitudEstado: number): boolean {
        const estadosValidos = [2, 3, 4, 5, 6, 7, 11];
        return estadosValidos.includes(idSolicitudEstado!);
    }
    fasesToEval = computed(() => {
        if(this.tramiteService._tramitesFasesEval().length === 0){
            return []
        }
        return this.tramiteService._tramitesFasesEval().filter(value => value.tramitesEvalResponse.length>0)
            .map(value => ({
            idFase: value.idFase,
            nombreFase: value.nombreFase
        }));
    });
    fasesTramitesValid = computed(() =>
        this.tramiteService._tramitesFasesEval().length > 0 && this.tramiteService._tramitesFasesEval().every(item => item.tramitesEvalResponse.length === 0));
}
